/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AiChatApi extends runtime.BaseAPI {
    /**
     * Get Ai Chat Stats
     */
    async getAiChatStatsApiV2AiChatStatsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/ai/chat/stats`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Ai Chat Stats
     */
    async getAiChatStatsApiV2AiChatStatsGet(initOverrides) {
        const response = await this.getAiChatStatsApiV2AiChatStatsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Stream Ai Chat
     */
    async streamAiChatApiV2AiChatStreamPostRaw(requestParameters, initOverrides) {
        if (requestParameters['aiChatRequest'] == null) {
            throw new runtime.RequiredError('aiChatRequest', 'Required parameter "aiChatRequest" was null or undefined when calling streamAiChatApiV2AiChatStreamPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/ai/chat/stream`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['aiChatRequest'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Stream Ai Chat
     */
    async streamAiChatApiV2AiChatStreamPost(requestParameters, initOverrides) {
        const response = await this.streamAiChatApiV2AiChatStreamPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Stream Ai Chat Audio
     */
    async streamAiChatAudioApiV2AiChatStreamAudioPostRaw(requestParameters, initOverrides) {
        if (requestParameters['payload'] == null) {
            throw new runtime.RequiredError('payload', 'Required parameter "payload" was null or undefined when calling streamAiChatAudioApiV2AiChatStreamAudioPost().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling streamAiChatAudioApiV2AiChatStreamAudioPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['payload'] != null) {
            formParams.append('payload', requestParameters['payload']);
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/ai/chat/stream-audio`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Stream Ai Chat Audio
     */
    async streamAiChatAudioApiV2AiChatStreamAudioPost(requestParameters, initOverrides) {
        const response = await this.streamAiChatAudioApiV2AiChatStreamAudioPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
